module.exports = __webpack_public_path__ + "img/logo_pos_indonesia2.83137016.png";